<div class="banner-secundario-cv">
	<div id="carousel-cv" class="carousel slide" data-bs-ride="carousel">
		<div class="carousel-inner">
			<div class="carousel-item active">
				<img src="/assets/img/carousel/2254256_RCcoverBuscas_trabajo_banners_2.png">
				<div class="  ">
					<div class="carousel-caption text-start">
						<h1>¿Buscas trabajo?</h1>
						<p><a class="btn btn-lg btn-primary" href="https://empleo.manpower.com.mx/Bolsa_Trabajo" target="_blank">ENVÍANOS TU CV</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>